module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Private availability check":"Availablility check"},"de":{"Private availability check":"Verfügbarkeitsprüfung"}}')
  delete Component.options._Ctor
}
